import { Easing, interpolate, useCurrentFrame } from 'remotion';

export const CAPSULE_COVER_PRIMARY_COLOR = '#ff6687';
export const CAPSULE_COVER_SECONDARY_COLOR = '#f5a0b5';
export const CAPSULE_COVER_DURATION_SEC = 1.5;

const ROW_COUNT = 7;

export const getCapsuleCoverRevealFrame = (durationInFrames: number) =>
  Math.ceil(durationInFrames / 2);

export function CapsuleCoverTransition({
  primaryColor = CAPSULE_COVER_PRIMARY_COLOR,
  secondaryColor = CAPSULE_COVER_SECONDARY_COLOR,
  durationInFrames,
}: {
  primaryColor?: string;
  secondaryColor?: string;
  durationInFrames: number;
}) {
  const frame = useCurrentFrame();
  const progress = durationInFrames <= 1 ? 1 : frame / (durationInFrames - 1);

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      {Array.from({ length: ROW_COUNT }, (_, index) => {
        const direction = index % 2 === 0 ? 1 : -1;
        const stagger = index * 0.018;
        const enterProgress = interpolate(progress, [stagger, 0.48], [0, 1], {
          extrapolateLeft: 'clamp',
          extrapolateRight: 'clamp',
          easing: Easing.out(Easing.cubic),
        });
        const exitProgress = interpolate(
          progress,
          [0.52 + (ROW_COUNT - index - 1) * 0.018, 1],
          [0, 1],
          {
            extrapolateLeft: 'clamp',
            extrapolateRight: 'clamp',
            easing: Easing.in(Easing.cubic),
          },
        );
        const translateX =
          direction * (1 - enterProgress) * -125 +
          direction * exitProgress * 125;

        return (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: `${(index * 100) / ROW_COUNT - 1}%`,
              left: '-12.5%',
              width: '125%',
              height: `${100 / ROW_COUNT + 2.2}%`,
              borderRadius: '9999px',
              backgroundColor: index % 3 === 1 ? secondaryColor : primaryColor,
              transform: `translateX(${translateX}%)`,
              willChange: 'transform',
            }}
          />
        );
      })}
    </div>
  );
}
